import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { clients } from '../data/mock';

const ClientsSection = () => {
  const row1 = clients.slice(0, Math.ceil(clients.length / 2));
  const row2 = clients.slice(Math.ceil(clients.length / 2));

  const LogoItem = ({ client }) => {
    const [imageError, setImageError] = useState(false);
    
    return (
      <div className="flex-shrink-0 mx-4">
        <div className="px-8 py-4 bg-white rounded-lg border border-[#E5E7EB] flex items-center justify-center min-w-[140px] h-[60px] hover:border-[#1C4B8A]/30 transition-colors">
          {!imageError && client.logo ? (
            <img 
              src={client.logo} 
              alt={`${client.name} logo`}
              className="max-h-8 max-w-[100px] object-contain opacity-50 hover:opacity-100 transition-opacity grayscale hover:grayscale-0"
              onError={() => setImageError(true)}
            />
          ) : (
            <span className="text-sm font-semibold text-[#1C4B8A]/60 whitespace-nowrap">
              {client.name}
            </span>
          )}
        </div>
      </div>
    );
  };

  return (
    <section id="clients" className="py-16 md:py-20 bg-white overflow-hidden">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <span className="badge-minimal mb-6">Our Clients</span>
          <h2 className="title-minimal mb-4">
            Trusted by <span className="title-accent">Leading Organizations</span>
          </h2>
          <p className="text-base text-[#4A4A5A] max-w-2xl mx-auto">
            We've successfully delivered cleanroom projects for pharmaceutical giants, 
            research institutions, and healthcare organizations across North America.
          </p>
        </motion.div>
      </div>

      {/* Scrolling Row 1 */}
      <div className="relative mb-4">
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-white to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-white to-transparent z-10" />
        <div className="flex animate-scroll-left">
          {[...row1, ...row1, ...row1].map((client, index) => (
            <LogoItem key={`row1-${index}`} client={client} />
          ))}
        </div>
      </div>

      {/* Scrolling Row 2 */}
      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-white to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-white to-transparent z-10" />
        <div className="flex animate-scroll-right">
          {[...row2, ...row2, ...row2].map((client, index) => (
            <LogoItem key={`row2-${index}`} client={client} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;
